import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { CartProvider } from "./contexts/CartContext";
import { Layout } from "./components/Layout";
import { Home } from "./pages/Home";
import { Shop } from "./pages/Shop";
import { ProductPage } from "./pages/ProductPage";
import { Cart } from "./pages/Cart";
export function App() {
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="2rlyr0hc56qkk">
      <CartProvider data-id="element-1" data-mp="2rit1x23ijoou">
        <BrowserRouter data-id="element-2" data-mp="2mlubatj25zve">
          <Routes data-id="element-3" data-mp="2mmlu13rk4349">
            <Route element={<Layout data-id="element-5" data-mp="2mndna7xolord" />} data-id="element-4" data-mp="2mn5b6i9dunh8">
              <Route path="/" element={<Home data-id="element-7" data-mp="31b8j3x6zk98o" />} data-id="element-6" data-mp="2mjzn96chprn3" />
              <Route path="/shop" element={<Shop data-id="element-9" data-mp="31c1iue7j1yhb" />} data-id="element-8" data-mp="31brzh9gzmpkl" />
              <Route path="/product/:id" element={<ProductPage data-id="element-11" data-mp="2wiyxuugtfxcq" />} data-id="element-10" data-mp="2wk0b95lb0vxm" />
              <Route path="/winkelwagen" element={<Cart data-id="element-13" data-mp="28u5y0mx2p5cu" />} data-id="element-12" data-mp="2wip7v6vrtq71" />
              <Route path="*" element={<Home data-id="element-15" data-mp="28sutulzptvl7" />} data-id="element-14" data-mp="28tmej1rry8wp" />
            </Route>
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </MotionConfig>;
}